<template>
  <div class="external-page">
    <lazy-hydrate when-visible>
      <external-new-banner />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-choose />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div>
        <main-certificate />
        <school-new-check-list />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-learn-lite />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-test />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-tariff />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-benefits />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-reviews />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <!-- eslint-disable -->
      <su-form
        title-prop="начните свой путь к&nbsp;успеху с&nbsp;нами"
        user-name="Татьяна Ведьманова"
        user-image="/v2/external-new/form/user.png"
        submit-text="оставить заявку"
      />
      <!-- eslint-enable -->
    </lazy-hydrate>

    <lazy-hydrate
      v-if="!externalCenyPage"
      when-visible
    >
      <external-new-articles />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-faq />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-necessary title="<h2>дополните обучение</h2>" />
    </lazy-hydrate>

    <lazy-hydrate
      v-if="!externalCenyPage"
      when-visible
    >
      <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />
    </lazy-hydrate>
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import LazyHydrate from 'vue-lazy-hydration';
import ExternalNewBanner from '../../components/v2/external-new/ExternalNewBanner.vue';
import ExternalNewChoose from '../../components/v2/external-new/ExternalNewChoose.vue';
import MainCertificate from '../../components/v2/main/MainCertificate.vue';
import SchoolNewCheckList from '../../components/v2/school-new/SchoolNewCheckList.vue';
import ExternalNewLearnLite from '../../components/v2/external-new/ExternalNewLearnLite.vue';
import ExternalNewTest from '../../components/v2/external-new/ExternalNewTest.vue';
import ExternalNewBenefits from '../../components/v2/external-new/ExternalNewBenefits.vue';
import SuReviews from '../../components/v2/school-university/SuReviews.vue';
import SuForm from '../../components/v2/school-university/SuForm.vue';
import ExternalNewArticles from '../../components/v2/external-new/ExternalNewArticles.vue';
import SuFaq from '../../components/v2/school-university/SuFaq.vue';
import MainNecessary from '../../components/v2/main/MainNecessary.vue';
import SchoolNewBreadcrumbs from '../../components/v2/school-new/SchoolNewBreadcrumbs.vue';
import ExternalNewTariff from '../../components/v2/external-new/ExternalNewTariff.vue';

export default {
  name: 'ExternalPage',
  components: {
    ExternalNewTariff,
    SchoolNewBreadcrumbs,
    MainNecessary,
    SuFaq,
    ExternalNewArticles,
    SuForm,
    SuReviews,
    ExternalNewBenefits,
    ExternalNewTest,
    ExternalNewLearnLite,
    SchoolNewCheckList,
    MainCertificate,
    ExternalNewChoose,
    ExternalNewBanner,
    LazyHydrate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    // для head
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=school_synergy_ru',
      defer: true,
      type: 'text/javascript',
    }],
    canonical: true,
  }),

  computed: {
    externalCenyPage() {
      return this.$route?.name === 'externat-ceny';
    },

    external5() {
      return this.$route.name === 'externat-5-7klass';
    },
    external8() {
      return this.$route.name === 'externat-8-9klass';
    },
    external10() {
      return this.$route.name === 'externat-10-11klass';
    },

    image() {
      if (this.external5) {
        return '/v2/external-new/share-image-5.jpg';
      }

      if (this.external8) {
        return '/v2/external-new/share-image-8.jpg';
      }

      if (this.external10) {
        return '/v2/external-new/share-image-10.jpg';
      }

      return '/v2/external-new/share-image.jpg';
    },
    title() {
      if (this.external5) {
        return `Школа экстернат 5-7 класс | Школьный Университет Синергия${this.$getTitleCityByHost()}`;
      }

      if (this.external8) {
        return `Школа экстернат 8-9 класс | Школьный Университет Синергия${this.$getTitleCityByHost()}`;
      }

      if (this.external10) {
        return `Школа экстернат 10-11 класс | Школьный Университет Синергия${this.$getTitleCityByHost()}`;
      }

      // eslint-disable-next-line max-len,vue/max-len
      return `Экстернат 5-11 классы онлайн | Ускоренное обучение с гос. аттестацией | Синергия${this.$getTitleCityByHost()}`;
    },
    description() {
      if (this.external5) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Пройди обучение экстерном в онлайн-школе «Синергия». Экспресс обучение по программе Экстернат для взрослых и детей';
      }

      if (this.external8) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Пройди обучение экстерном в онлайн-школе «Синергия». Экспресс обучение по программе Экстернат для взрослых и детей';
      }

      if (this.external10) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Пройди обучение экстерном в онлайн-школе «Синергия». Экспресс обучение по программе Экстернат для взрослых и детей';
      }

      // eslint-disable-next-line max-len,vue/max-len
      return 'Онлайн-экстернат для школьников 5-11 классов. Пройдите программу быстрее, получите аттестат гос. образца и подготовьтесь к ЕГЭ/ОГЭ. Гибкий график, поддержка куратора, скидки до 60%';
    },

    breadcrumbs() {
      const breadcrumbs = [{ text: 'главная', to: '/' }];

      if (this.external5) {
        breadcrumbs.push({ text: 'экстернат 5-7 класс', to: '/externat/5-7klass' });
        return breadcrumbs;
      }

      if (this.external8) {
        breadcrumbs.push({ text: 'экстернат 8-9 класс', to: '/externat/8-9klass' });
        return breadcrumbs;
      }

      if (this.external10) {
        breadcrumbs.push({ text: 'экстернат 10-11 класс', to: '/externat/10-11klass' });
        return breadcrumbs;
      }

      breadcrumbs.push({ text: 'экстернат для детей', to: '/externat' });
      return breadcrumbs;
    },
  },

  created() {
    this.scrollTop();
  },

  methods: {
    scrollTop() {
      if (process.client) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        });
      } else {
        setTimeout(this.scrollTop, 50);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.external-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 24);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.main-title),
  ::v-deep(.su-title) {
    position: relative;
    font-family: 'Onest', sans-serif;
    margin-bottom: calc(var(--scale) * 44);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      margin-bottom: calc(var(--scale) * 20);
    }

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 40);
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  ::v-deep(.su-form) {
    .su-form__info {
      background-color: #ffffff;

      .su-form__info_soc p {
        @include media-down($size-tablet) {
          color: #A7ABAC;
        }
      }
    }

    .su-form__form {
      background-image: url("/v2/external-new/bg-green.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/external-new/bg-form-mob.webp");
      }

      .phone-field,
      input {
        border-radius: 100px;
        background-color: #ffffff;
        color: #02120F;

        &::placeholder {
          color: #A7ABAC;
        }
      }
    }
  }

  ::v-deep(.other-school-support__banner) {
    button {
      @include media-down($size-mobile) {
        width: calc(100% + calc(var(--scale) * 16));
        margin-bottom: calc(-1 * var(--scale) * 8);
        margin-left: calc(-1 * var(--scale) * 8);
        padding: calc(var(--scale) * 30);
        background-color: #76195A;
        box-shadow:
          calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
        border-radius: calc(var(--scale) * 24);

        font-weight: 500;
        font-size: calc(var(--scale) * 18);
        line-height: 110%;
        letter-spacing: -0.02em;
        color: #FFFFFF;
      }
    }
  }

  ::v-deep(.su-faq) {
    background-color: #ffffff;
  }
}
</style>
